/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment, useEffect, useState } from "react";
import {
    useMediaQuery,
    useTheme,
    MenuItem,
    AppBar,
    Badge,
    Avatar,
    Divider,
    Menu,
    List,
    Tooltip
} from "@mui/material";
import { AlertMsgTh, AlertTitleTh, AxiosGet, AxiosPost, NoPermission, NoPermissionVOC, ResultAPI } from "service/CommonFunction/TS_function";
import themes from "./../../themes";

import { Drawer, Grid } from "@mui/material";
import "./LayoutBack.css";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LogoPTT from "../../assets/Image/logo-ptt.png";
import UserAvatar from "../../assets/Image/user-avatar.png";
import BackLayout from "../../assets/Image/BackLayout.jpg";

//Icon
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Logout } from "@mui/icons-material";
import { FaSignOutAlt } from "react-icons/fa";

//MUI CSS
import ListHeadMenu from "./Menu/ListHeadMenu";
import { SwAlert } from "components/Common/Alert/AlertForm";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import secureLocalStorage from "react-secure-storage";
import { AuthToken, useUnauthorize } from "service/CommonFunction/AxiosConfig";
import jwt_decode from "jwt-decode";


const LayoutBack = ({ children, propLayout }) => {

    const location = useLocation();
    const theme = useTheme();
    const isMatchMobile = useMediaQuery(theme.breakpoints.down("md"));
    const Layout1200 = useMediaQuery('(min-width:1200px)');
    const navigate = useNavigate();


    const [sidebar, setSidebar] = React.useState(false);

    const [items, setItems] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [nAllNotify, setnAllNotify] = useState(99)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const IsOpenNotify = Boolean(anchorEl);
    const [userImg, setUserImage] = useState(null);


    const [dataMenu, setDataMenu] = useState([] as any);
    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sPathImage": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sRoleMax": null,
        "sUserType": null,
        "sRolePIS": null,
        "lstCompany": [],
        "lstUserBA": [],
        "sBA": null
    })
    const [openDrawer, setOpenDrawer] = useState(false);

    useEffect(() => {
        GetUserData();
        onGetMenu();
    }, [])

    useEffect(() => {
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const strMail = urlParams.get("strMail");
        const strUser = "E";

        if(strMail && strUser == "E")
        {   
            let LinkTo = window.location.href;
            secureLocalStorage.setItem("LinkTo",LinkTo)
            secureLocalStorage.setItem("sUserType",strUser)
            onCheckTokenExpired(LinkTo);
        } 

    }, [])

    useEffect(() => {
        AxiosGet(`Authentication/CheckUserPermission`, { sPath: location.pathname }, (res) => {
            ResultAPI(res, null, () => {
                if (!res.IsHasPermission) {
                    NoPermission()
                }
            })
        })

        secureLocalStorage.setItem('languageUvoice', "th");
        GetNotify(0);
    }, [location.pathname])

    const onCheckTokenExpired = (LinkTo) => {
        let sToken = AuthToken.get() as string;
        let strUser = secureLocalStorage.getItem("sUserType") as string;
        if (sToken) {
            let decodedHeader = jwt_decode(sToken) as any;
            let nowDate = new Date();
            const dExp = new Date(0);
            dExp.setUTCSeconds(decodedHeader.exp);//Fix Date Exp

            if (dExp.valueOf() > nowDate.valueOf()) {
                //ยังไม่หมดอายุ
                // AuthToken.set(sToken);
                //Link To Path
                if(strUser == decodedHeader.USER_TYPE )
                {
                    if(LinkTo != window.location.href)
                    {
                        onGetLinkAndGotoLink(LinkTo);
                    }
                }
                else
                {
                    //No permission
                    NoPermissionVOC();
                }
            }
            else
            {
                if(strUser == "E")
                {
                    //ให้ไป LoginAD
                    onGotoLoginAD();
                }
            }
        }
        else
        {
            if(strUser == "E")
            {
                //ให้ไป LoginAD
                onGotoLoginAD();
            }
        }
    }

    const onGetLinkAndGotoLink =(LinkTo)=>{
        if(LinkTo && LinkTo != "")
        {
            let anchor = document.createElement("a");
            anchor.href = LinkTo;
            secureLocalStorage.removeItem("LinkTo");
            secureLocalStorage.removeItem("sUserType");
            anchor.click();
        }
        else
        {
            secureLocalStorage.removeItem("LinkTo");
            secureLocalStorage.removeItem("sUserType");
            navigate("/Home")
            window.location.reload();
        }
    }

    const onGotoLoginAD =()=>{
        let sSiteAD = process.env.REACT_APP_LOGINAD;
        let anchor = document.createElement("a");
        anchor.href = sSiteAD;
        anchor.click();
    }

    const GetNotify = (length) => {
        let data = {
            Itemlength: length
        };
        AxiosPost(`Notify/GetMoreNotify`, data, (res) => {
            ResultAPI(res, null, async () => {
                let ArrNotify = res.ArrNotify || [];
                setItems([...ArrNotify])
                setnAllNotify(res.nCountComponent)
            })
        })
    };

    const fetchMoreData = () => {
        let arr = [...items];

        if (arr.length > 0) {
            if (arr.length >= nAllNotify) {
                sethasMore(false);
            }
            else {
                if (items.length > 0) {
                    sethasMore(true);
                }
                let data = {
                    Itemlength: items.length || 0
                };
                AxiosPost(`Notify/GetMoreNotify`, data, (res) => {
                    ResultAPI(res, null, async () => {
                        let ArrNotify = res.ArrNotify || [];
                        setItems([...arr, ...ArrNotify])
                        setnAllNotify(res.nCountComponent)
                        if (ArrNotify.length == 0) {
                            sethasMore(false);
                        }
                    })
                })
            }
        }
    };

    const onGetMenu = async () => {
        AxiosGet("Systems/GetMenuBack", {}, (res) => {
            setDataMenu(res.lstMenu);
        })
    };

    const GetUserData = async () => {
        AxiosGet("User/GetUserData", { "sLanguage": "th" }, (res) => {
            ResultAPI(res, null, () => {
                if (res.result.IsReset == true) {
                    navigate("/Front/Profile")
                }

                if (res.result.sUserType === "E" || res.result.sUserType === "O") {
                    if (res.result.sPathImage) {
                        const img = new Image()
                        img.src = res.result.sPathImage
                        var result = new Promise((resolve) => {
                            img.onload = () => resolve(true);
                            img.onerror = () => resolve(false);
                        });
                        result.then(reustItem => {
                            var img = reustItem ? res.result.sPathImage : UserAvatar
                            setUserImage(img)
                        })
                    } else {
                        setUserImage(UserAvatar)
                    }

                    setDataUser({
                        "nUserID": res.result.nUserID || null,
                        "sUserCode": res.result.sUserCode || null,
                        "sPathImage": res.result.sPathImage || null,
                        "sFullname": res.result.sFullname || null,
                        "sAPIRoleName": res.result.sAPIRoleName || null,
                        "sRolePIS": res.result.sLevelName,
                        "sRoleMax": res.result.sRoleMax || null,
                        "sUserType": res.result.sUserType || null,
                        "lstCompany": res.result.lstCompany || [],
                        "lstUserBA": res.result.lstUserBA || [],
                        "sBA": res.result.sBA
                    });
                } else {
                    navigate("/Home")
                    useUnauthorize.set(true)
                    useUnauthorize.set(false)
                }
            })
        })
    };

    const handleDrawerOpen = () => {
        setSidebar(!sidebar);
    };

    const showSidebar = () => setSidebar(!sidebar);

    const handleDrawerOpenMobile = () => {
        setOpenDrawer(!openDrawer);
    };

    const onHandleLogout = (isFront: boolean) => {
        SwAlert.Confirm(AlertTitleTh.Confirm, AlertMsgTh.confirmLogout, () => {
            secureLocalStorage.clear();
            secureLocalStorage.setItem('languageUvoice', "th");
            setDataUser(null)
            navigate("/Home");
        });

    }

    const onHandleOpenNotify = (event) => {
        GetNotify(0);
        setAnchorEl(event.currentTarget);
    }

    const ReadNotify = (nNotifyID) => {
        AxiosGet(`Notify/ReadNotify`, { "nNotifyID": nNotifyID }, (res) => {
            ResultAPI(res, null, async () => {
                setAnchorEl(null);
            })
        })
    };

    const ListNotify = () => {
        return (
            <Menu
                anchorEl={anchorEl}
                id="scrollableDiv"
                open={IsOpenNotify}
                onClose={() => { 
                    setAnchorEl(null); 
                    GetNotify(0); 
                    setnAllNotify(99);
                    sethasMore(true); 
                }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        width: 320,
                        height: 300,
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <InfiniteScroll
                    dataLength={items.length}
                    next={fetchMoreData}
                    height={290}
                    hasMore={hasMore}
                    loader={items.length > 0 ? <h4 style={{ textAlign: 'center' }}>กำลังโหลด</h4> : null}
                    scrollableTarget="scrollableDiv"
                >
                    <div key={`notify_head`} className={'sticky-notify'}>
                        <Typography style={{ padding: '6px 12px', fontSize: '0.7em' }}>การแจ้งเตือน</Typography>
                        <Divider />
                    </div>
                    <div key={`notify_item`} >
                        {items.map((item, ind) => {
                            let nJobTypeID = item?.nJobTypeID;
                            let nStatus = item?.nStatus;
                            let nVOCFormTypeID = item?.nVOCFormTypeID;
                            return (
                                <Fragment key={`notify_${ind}`}>
                                    <MenuItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '2px 15px 2px 16px' }}>
                                        {
                                            item.isDate ?
                                                <div>
                                                    <Typography style={{ fontSize: '0.8em', fontWeight: 500 }}>{moment(item.dNotify).add(543, 'year').format("DD MMM YY")}</Typography>
                                                </div>
                                                :
                                                <Link
                                                    to={item.nNotifyTypeID == 5 && item.isJobCode != true && nVOCFormTypeID != 2 ? "/Backend/HomeBackEnd/PageClassifyIssue" : nVOCFormTypeID == 2 ? "/Backend/VOCFormTrackingList/PageProductAndService" : nJobTypeID === 1 ? "/Backend/VOCFormTrackingList/PageComplaint" : nJobTypeID === 2 ? "/Backend/VOCFormTrackingList/PageRequest" : "/Backend/VOCFormTrackingList/PageSuggest"}
                                                    onClick={() => { ReadNotify(item.nNotifyID) }}
                                                    state={{ sVOCFormID: item.sVOCFormID }}
                                                    style={{ width: '100%' }}
                                                >
                                                    <div className="item-notify" style={{ width: '100%', position: 'relative', padding: '4px 9px 4px 12px' }}>
                                                        <div style={{ position: 'absolute', top: 4, right: 8, fontSize: '0.7em' }}>{item.dNotify != "" ? moment(item.dNotify).format("HH:mm") : ""}</div>
                                                        {item.isRead ? null : <div style={{ position: 'absolute', top: '11px', left: '-15px' }}><FiberManualRecordIcon style={{ fontSize: '8px', color: '#7a00ff' }} /></div>}
                                                        <Typography style={{ fontSize: '0.8em', fontWeight: 500 }}>{item.sVOCFormCode ?? ""}</Typography>
                                                        <Typography style={{ fontSize: '0.8em' }}>{item.sTypeNotify ?? ""}</Typography>
                                                    </div>
                                                </Link>

                                        }
                                    </MenuItem>
                                    {/* <Divider style={{ margin: '0' }} /> */}
                                </Fragment>
                            )
                        })}
                    </div>
                </InfiniteScroll>
            </Menu>
        )
    }

    return (
        <>
            <Box sx={{ display: 'flex' }}>
                {isMatchMobile ?
                    // Mobile
                    <>
                        <CssBaseline />
                        <AppBar
                            position="fixed"
                            sx={{ backgroundColor: "white", color: "gray", zIndex: 1500 }}
                        >
                            <Toolbar>
                                <IconButton
                                    size="small"
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={() => { handleDrawerOpenMobile() }}
                                    sx={{
                                        mr: 1,
                                        color: "#0288d1"
                                    }}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Link to="/Home" preventScrollReset={true}>
                                    <img
                                        alt={"PTT Logo"}
                                        style={{ cursor: "pointer", objectFit: "contain" }}
                                        width="100px"
                                        src={LogoPTT}
                                    />
                                </Link>
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        textDecoration: "none",
                                        paddingLeft: "10px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography sx={{ color: "#443a78", fontSize: "25px", fontWeight: "bold", [themes.breakpoints.down('sm')]: { display: "none", } }}>
                                        GBU Voice of Customer
                                    </Typography>
                                </Box>
                                <IconButton
                                    sx={{ color: '#1586b9', marginLeft: "auto" }}
                                    onClick={(event: React.MouseEvent<HTMLElement>) => { onHandleOpenNotify(event) }}
                                >
                                    {items.length === 0 ?
                                        <NotificationsIcon style={{ fontSize: '1.5rem' }} />
                                        :
                                        <Badge color="error" variant="dot">
                                            <NotificationsActiveIcon style={{ fontSize: '1.5rem' }} />
                                        </Badge>
                                    }
                                </IconButton>
                                <Tooltip title="ออกจากระบบ">
                                    <IconButton onClick={() => { onHandleLogout(true) }}>
                                        <FaSignOutAlt style={{ fontSize: '1.5rem', color: 'red' }} />
                                    </IconButton>
                                </Tooltip>
                            </Toolbar>
                        </AppBar>
                        <Drawer
                            anchor="left"
                            open={openDrawer}
                            onClose={() => setOpenDrawer(false)}
                        >
                            <Box
                                sx={{ width: 250, overflow: 'hidden' }}
                                role="presentation"
                                style={{
                                    marginTop: '57px',
                                    overflowY: 'auto',
                                    zIndex: 1000,
                                }}
                            >
                                <div style={{ width: '100%', height: '225px', padding: '16px', background: 'linear-gradient(135deg,#c4edff,#ffe7f9)', display: 'flex', boxShadow: '0px 7px 7px -7px #888888' }}>
                                    <Grid container direction={'column'} spacing={1} justifyContent={'space-evenly'} alignItems='center'>
                                        <Grid item xs={'auto'}>
                                            <Avatar src={userImg ?? UserAvatar} style={{ width: '5em', height: '5em' }} />
                                        </Grid>
                                        <Grid item xs={'auto'}>
                                            <p style={{ marginBottom: '4px', textAlign: 'center' }}>{DataUser?.sFullname}</p>
                                            <p style={{ marginBottom: '4px', textAlign: 'center' }}>ROLE</p>
                                        </Grid>
                                    </Grid>
                                </div>
                                {/* <List sx={{ padding: "20px !important" }}> */}
                                <List>
                                    <ListHeadMenu
                                        dataMenu={dataMenu}
                                        sidebar={sidebar}
                                        fnShowSidebar={showSidebar}
                                        isShowIcon={true}
                                        setIsDrawerMenu={false}

                                    />
                                </List>
                            </Box>
                        </Drawer>
                    </>
                    :
                    // WEB
                    <>
                        <CssBaseline />
                        <AppBar
                            position="fixed"
                            sx={{ backgroundColor: "white", color: "gray", zIndex: 1500 }}
                        >
                            <Toolbar>
                                <IconButton
                                    size="small"
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={() => { handleDrawerOpen() }}
                                    sx={{
                                        mr: 1,
                                        color: "#0288d1"
                                    }}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Link to="/Home" preventScrollReset={true}>
                                    <img
                                        alt={"PTT Logo"}
                                        style={{ cursor: "pointer", objectFit: "contain" }}
                                        width="100px"
                                        src={LogoPTT}
                                    />
                                </Link>
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        textDecoration: "none",
                                        paddingLeft: "10px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography sx={{ color: "#443a78", fontSize: "25px", fontWeight: "bold", [themes.breakpoints.down('sm')]: { display: "none", } }}>
                                        GBU Voice of Customer
                                    </Typography>
                                </Box>
                                <IconButton
                                    sx={{ color: '#1586b9', marginLeft: "auto" }}
                                    onClick={(event: React.MouseEvent<HTMLElement>) => { onHandleOpenNotify(event) }}
                                >
                                    {items.length === 0 ?
                                        <NotificationsIcon style={{ fontSize: '1.5rem' }} />
                                        :
                                        <Badge color="error" variant="dot">
                                            <NotificationsActiveIcon style={{ fontSize: '1.5rem' }} />
                                        </Badge>
                                    }
                                </IconButton>
                                <div style={{ width: '10em', textAlign: 'center' }}>
                                    <Typography sx={{ padding: '0px 1%', color: "#000000", fontSize: "13px", fontWeight: 500, textAlign: 'center' }}>
                                        {DataUser.sFullname ? "คุณ" + DataUser.sFullname : null}
                                    </Typography>
                                    {
                                        DataUser.sRolePIS ?
                                            <Typography sx={{ padding: '0px 1%', color: "#757575", fontSize: "13px", fontWeight: 500, textAlign: 'center' }}>
                                                {DataUser.sRolePIS}
                                            </Typography>
                                            :
                                            DataUser.sRoleMax ?
                                                <Typography sx={{ padding: '0px 1%', color: "#757575", fontSize: "13px", fontWeight: 500, textAlign: 'center' }}>
                                                    {DataUser.sRoleMax}
                                                </Typography>
                                                : null
                                    }
                                </div>
                                <Tooltip title="ออกจากระบบ">
                                    <IconButton
                                        onClick={() => { onHandleLogout(true) }}
                                        sx={{ color: "white", marginLeft: "auto" }}
                                    >
                                        <FaSignOutAlt style={{ fontSize: '1.5rem', color: 'red' }} />
                                    </IconButton>
                                </Tooltip>

                            </Toolbar>
                        </AppBar>
                        <Drawer
                            variant="permanent"
                            style={{
                                transition: 'width 0.2s ease',
                            }}
                            sx={{
                                width: sidebar ? 60 : 260,
                                zIndex: 1000,
                                flexShrink: 0,
                                [`& .MuiDrawer-paper`]: { width: sidebar ? 60 : 260, boxSizing: 'border-box' },
                            }}
                        >
                            <Toolbar />
                            {sidebar
                                ?
                                <>
                                    <div style={{ width: '100%', height: '70px', padding: '16px', background: 'linear-gradient(135deg,#c4edff,#ffe7f9)', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                        <Grid container justifyContent={'center'} alignItems='center'>
                                            <Grid item>
                                                <Tooltip title={DataUser?.sFullname} placement="right">
                                                    {/* <Avatar>{DataUser?.sFullname != null ? DataUser.sFullname.charAt(0) : "H"}</Avatar> */}
                                                    <Avatar src={userImg ?? UserAvatar} />
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </>
                                :
                                <>
                                    <div style={{ width: '100%', padding: '16px', background: 'linear-gradient(135deg,#c4edff,#ffe7f9)', display: 'flex', boxShadow: '0px 7px 7px -7px #888888' }}>
                                        <Grid container direction={'column'} spacing={1} justifyContent={'space-evenly'} alignItems='center'>
                                            <Grid item xs={'auto'}>
                                                {/* <Avatar style={{ width: '5em', height: '5em' }}>{DataUser?.sFullname != null ? DataUser.sFullname.charAt(0) : "H"}</Avatar> */}
                                                <Avatar src={userImg ?? UserAvatar} style={{ width: '5em', height: '5em' }} />
                                            </Grid>
                                            <Grid item xs={'auto'}>
                                                <p style={{ marginBottom: '4px', textAlign: 'center' }}>{DataUser?.sFullname}</p>
                                                {DataUser.sRolePIS ?
                                                    <Typography sx={{ padding: '0px 1%', color: "#757575", fontSize: "13px", fontWeight: 500, textAlign: 'center' }}>
                                                        {DataUser.sRolePIS}
                                                    </Typography>
                                                    :
                                                    DataUser.sRoleMax ?
                                                        <p style={{ marginBottom: '4px', textAlign: 'center' }}>
                                                            {DataUser.sRoleMax}
                                                        </p>
                                                        : null
                                                }
                                                {DataUser.sRoleMax != "Super Admin" && <p style={{ fontSize: "10pt", textAlign: 'center' }}>กลุ่มตลาด : {DataUser.sBA}</p>}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </>}
                            <Box sx={{ overflowY: 'auto', padding: "10px 0" }}>
                                <ListHeadMenu
                                    dataMenu={dataMenu}
                                    sidebar={sidebar}
                                    fnShowSidebar={showSidebar}
                                    isShowIcon={true}
                                    setIsDrawerMenu={false}
                                />
                            </Box>
                        </Drawer>
                    </>
                }
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: isMatchMobile ? 2 : 2.5,
                        backgroundImage: `url(${BackLayout})`,
                        backgroundSize: "cover",
                        backgroundPositionX: "center",
                        backgroundPositionY: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: '#f2f2f2',
                        minHeight: '100vh',
                        height: '100%',
                        width: '100%'
                    }}
                >
                    <Toolbar />
                    <Grid container justifyContent={'center'} alignItems={'start'}>
                        <Grid item xs={12}>
                            {children}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {ListNotify()}

        </>
    )
}

export default LayoutBack